module.exports = __webpack_public_path__ + "img/tv-01.bc85f26b.svg";